require('./contractLoanNumberSelector.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;
const classnames = require('classnames');

class ContractLoanNumberSelector extends React.Component {

    handleClick(term) {
        this.props.onChange(term);
    }

    buildOption(term) {
        const { selectedValue, optionStyle, name } = this.props;
        const id = `contract-loan-number-selector-${term}`;
        const isSelected = selectedValue === term;

        return (
            <span key={id} className={optionStyle}>
                <input
                    type="radio"
                    name={name}
                    id={id}
                    onClick={() => {
                        this.handleClick(term)
                    }}
                    className="contract-loan-number-selector__input"
                    checked={isSelected}
                />
                <label
                    className="contract-loan-number-selector__label"
                    htmlFor={id}
                >
                    {term}
                </label>
            </span>
        );
    }

    render() {
        const { termValues, titleText, titleStyle, componentStyle, errorState } = this.props;
        const options = termValues.map(term => this.buildOption(term));

        const containerStyles = classnames({
            'contract-loan-number-selector--error': errorState
        },
            componentStyle
        );

        return (
            <div className={containerStyles}>
                <FormattedText
                    value={titleText}
                    className={titleStyle}
                />
                <div className="contract-loan-number-selector__container">
                    {options}
                </div>
            </div>
        );
    }
}

ContractLoanNumberSelector.propTypes = {
    termValues: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    optionStyle: PropTypes.string,
    componentStyle: PropTypes.string,
    selectedValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    titleText: PropTypes.string,
    titleStyle: PropTypes.string,
    errorState: PropTypes.bool
};

module.exports = ContractLoanNumberSelector;
